<section class="preorder">
  <div class="ordered-header">
    <div class="green-border" (click)='back()'>
      <i class="arrow left"></i>

      <span class="back">{{ "Back" | translate }}</span>
    </div>

    <div class="container-title">
      <p class="preorder-title">{{ "Preorder" | translate }}</p>
    </div>
    <div class="green-border-invisible">
      <i class="arrow left"></i>
      <span class="back">{{ "Back" | translate }}</span>
    </div>
  </div>

  <div class="main">
    <div class="parent">
      <div class="div1">
        <p>{{ "Item" | translate }}</p>
      </div>
      <div class="div2">
        <p>{{ "Description" | translate }}</p>
      </div>
      <div class="div3">
        <p>{{ "Unit.Price" | translate }}</p>
      </div>
      <div class="div4">
        <p>{{ "Quantity" | translate }}</p>
      </div>
      <div class="div5">
        <p>{{ "Total.Price" | translate }}</p>
      </div>
      <div class="div6" [ngClass]="{ 'div6-none': !shirt }" *ngIf="this.shirt">
        <div class="jersey-preview-holder">
          <img class="jersey-image" src="https://strapi.alkesoccer.com{{ shirt.Image.url }}" alt="" />
          <div
            [ngClass]="shirt?.maillot_modele?.Colibri_type === 'Centre' ? 'front-input center-shirt' : 'front-input bottom-shirt'">
            <img *ngIf="image?.frontImage" [src]="image?.frontImage" />
          </div>
          <div class="heart-input">
            <img *ngIf="image?.heartImage" [src]="image?.heartImage" />
          </div>
          <div class="left-input">
            <div class="logo-container">
              <img *ngIf="image?.leftImage" [src]="image?.leftImage" />
            </div>
          </div>
          <div class="right-input">
            <div class="logo-container">
              <img *ngIf="image?.rightImage" [src]="image?.rightImage" />
            </div>
          </div>
        </div>
        <p class="text-price">
          <app-unit-price [product]="shirt.maillot_modele" [quantity]="shirtInput"></app-unit-price>
          <span class="mobile-price">*</span>
        </p>
        <div class="align-space-around quantity-shirt">
          <img src="assets/images/minus.svg" alt="" (click)="decrementShirt()" />
          <input type="number" (change)="shirtInputChange($event)" value="{{ shirtInput }}" />
          <img src="assets/images/Union.svg" alt="" (click)="incrementShirt()" />
        </div>
      </div>
      <p class="text-hint" *ngIf="displayShirtMessage">
        {{ "Hint" | translate }}
      </p>
      <div class="div7-none" [ngClass]="{ div7: shirt }" *ngIf="this.shirt">

        <div class="grey-background">
          <p>{{ "Kit.Model" | translate }} {{ shirt.maillot_modele.Name | translate}}</p>
          <p>{{ "Kit.Color" | translate }} {{ shirtColor | translate}}</p>
          <p>
            {{ "Kit.Color.Colibri" | translate }} {{ shirt.couleur_colibri | translate}}
          </p>
          <p>{{ "Kit.Logo.Sponsor" | translate }} {{ uploadedImages }}</p>
          <p>{{ "Kit.Color.Name.Number" | translate }} {{ nameColor | translate}}</p>
          <p>{{ "Kit.Floquage.Name" | translate }} {{ noName | translate}}</p>
          <p>{{ "Kit.Floquage.Number" | translate }} {{ noNumber | translate}}</p>
        </div>
      </div>
      <div class="notice-text" *ngIf="this.shirt">
        <p>{{'NoticeText.Line1' | translate}}</p>
        <p *ngIf="shirtInput < 10">{{'NoticeText.Line2' | translate}}</p>
      </div>
      <div class="div8-none" [ngClass]="{ div8: shirt }" *ngIf="this.shirt">
        <app-unit-price [product]="shirt.maillot_modele" [quantity]="shirtInput"></app-unit-price>
      </div>
      <div class="div9-none" [ngClass]="{ div9: shirt }" *ngIf="this.shirt">
        <div class="align-space-around">
          <img src="assets/images/minus.svg" alt="" (click)="decrementShirt()" />
          <input type="number" (change)="shirtInputChange($event)" value="{{ shirtInput }}" />
          <img src="assets/images/Union.svg" alt="" (click)="incrementShirt()" />
        </div>
        <p *ngIf="!displayShirtMessage">
        </p>
        <p *ngIf="displayShirtMessage">
          {{ "Hint" | translate }}
        </p>
      </div>
      <div class="div10-none" [ngClass]="{ 'div10': shirt }" *ngIf="this.shirt">
        <p class="total">{{ this.shirtTotalPrice | currency:'EUR':true}}</p>
      </div>
      <div class="div11-none flex-align" [ngClass]="{ 'div11': short }" *ngIf="this.short">
        <div class="short-preview-holder">
          <img src="https://strapi.alkesoccer.com{{ short.image.url }}" alt="" />
          <div class="short-input"
            [ngClass]="short?.short_modele?.id === 2 ? 'mi-long' : short?.short_modele?.id === 3 ? 'sous-short' : ''">
            <img *ngIf="image?.shortImage" [src]="image?.shortImage" />
          </div>
        </div>
        <p class="text-price">
          <app-unit-price [product]="short.short_modele" [quantity]="shortInput"></app-unit-price>
          <span class="mobile-price">*</span>
        </p>
        <div class="align-space-around quantity-shirt">
          <img src="assets/images/minus.svg" alt="" (click)="decrementShort()" />
          <input type="number" (change)="shortInputChange($event)" value="{{ shortInput }}" />
          <img src="assets/images/Union.svg" alt="" (click)="incrementShort()" />
        </div>
      </div>
      <p class="text-hint" *ngIf="displayShortMessage">
        {{ "Hint" | translate }}
      </p>
      <div class="div12-none" [ngClass]="{ 'div12': short }" *ngIf="this.short">
        <div class="grey-background">
          <p>{{ "Kit.Color" | translate }} {{ shortColor| translate}}</p>
        </div>
      </div>
      <div class="notice-text" *ngIf="this.short">
        <p>{{'NoticeText.Line1' | translate}}</p>
        <p *ngIf="shortInput < 10">{{'NoticeText.Line2' | translate}}</p>
      </div>
      <div class="div13-none" [ngClass]="{ div13: short }" *ngIf="this.short">
        <app-unit-price [product]="short.short_modele" [quantity]="shortInput"></app-unit-price>
      </div>
      <div class="div14-none" [ngClass]="{ 'div14': short }" *ngIf="this.short">
        <div class="align-space-around">
          <img src="assets/images/minus.svg" alt="" (click)="decrementShort()" />
          <input type="number" (change)="shortInputChange($event)" value="{{ shortInput }}" />
          <img src="assets/images/Union.svg" alt="" (click)="incrementShort()" />
        </div>
        <p *ngIf="!displayShortMessage">
        </p>
        <p *ngIf="displayShortMessage">
          {{ "Hint" | translate }}
        </p>
      </div>

      <div class="div15-none" [ngClass]="{ 'div15': short }" *ngIf="this.short">
        <p>{{ shortTotalPrice | currency:'EUR':true}}</p>
      </div>
      <div class="div16-none flex-align" [ngClass]="{ 'div16': socks }" *ngIf="this.socks">
        <img class="sock-preview-holder" src="https://strapi.alkesoccer.com{{ socks.image.url }}" alt="" />

        <p class="text-price">
          <app-unit-price [product]="socks" [quantity]="socksInput"></app-unit-price>
          <span class="mobile-price">*</span>
        </p>

        <div class="align-space-around quantity-shirt">
          <img src="assets/images/minus.svg" alt="" (click)="decrementSocks()" />
          <input type="number" (change)="socksInputChange($event)" value="{{ socksInput }}" />
          <img src="assets/images/Union.svg" alt="" (click)="incrementSocks()" />
        </div>
      </div>
      <p class="text-hint" *ngIf="displaySocksMessage">
        {{ "Hint" | translate }}
      </p>
      <div class="div17-none" [ngClass]="{ 'div17': socks }" *ngIf="this.socks">
        <div class="grey-background">
          <p>{{ "Kit.Color" | translate }} {{ socks.couleur | translate}}</p>
        </div>
      </div>
      <div class="notice-text" *ngIf="this.socks">
        <p>{{'NoticeText.Line1' | translate}}</p>
        <p *ngIf="socksInput < 10">{{'NoticeText.Line2' | translate}}</p>
      </div>
      <div class="div18-none" [ngClass]="{ div18: socks }">
        <app-unit-price [product]="socks" [quantity]="socksInput"></app-unit-price>
      </div>
      <div class="div19-none" [ngClass]="{ 'div19': socks }" *ngIf="this.socks">
        <div class="align-space-around">
          <img src="assets/images/minus.svg" alt="" (click)="decrementSocks()" />
          <input type="number" (change)="socksInputChange($event)" value="{{ socksInput }}" />
          <img src="assets/images/Union.svg" alt="" (click)="incrementSocks()" />
        </div>
        <p *ngIf="!displaySocksMessage">
        </p>
        <p *ngIf="displaySocksMessage">
          {{ "Hint" | translate }}
        </p>
      </div>
      <div class="div20-none" [ngClass]="{ 'div20': socks }" *ngIf="this.socks">
        <p>{{ this.socksTotalPrice | currency:'EUR':true}}</p>
      </div>
    </div>
    <p class="total-price">
      {{ "Total.Price" | translate }} &nbsp;&nbsp;&nbsp; {{ kitTotalAmount | currency:'EUR':true}}
    </p>
  </div>
  <div class="multi-btn-container">
    <div (click)="getAdvice()" class="btn-white">
      <p>{{ "Get.Advice" | translate }}</p>
    </div>
    <div (click)="keepForLater()" class="btn-white">
      <p>{{ "Keep.Later" | translate }}</p>
    </div>
    <div (click)="goToQuotation()" class="btn-green">
      <p>{{ "Quotation" | translate }}</p>
    </div>
  </div>
</section>
